<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div class="mb-25">
        <h5 class="fw-bold text-black">{{ title }}</h5>
      </div>

      <Form ref="tariffZoneForm" @submit="addTariffZone" :validation-schema="tariffZoneSchema">
        <div class="row">
          
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="form-check">
                <Field name="isDefault" type="checkbox" class="form-check-input" id="isDefault" :value="true" :unchecked-value="false" />
                <label class="form-check-label text-black fw-semibold" for="isDefault">
                  Zone par défaut
                </label>
              </div>
              <ErrorMessage name="isDefault" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="form-check">
                <Field name="isActive" type="checkbox" class="form-check-input" id="isActive" :value="true" :unchecked-value="false" />
                <label class="form-check-label text-black fw-semibold" for="isActive">
                  Active
                </label>
              </div>
              <ErrorMessage name="isActive" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4"></div>

          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Code <span class="text-danger">*</span>
              </label>
              <Field name="code" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le code" />
              <ErrorMessage name="code" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nom <span class="text-danger">*</span>
              </label>
              <Field name="name" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nom" />
              <ErrorMessage name="name" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Continent(s) d'origine du chargement <span class="text-danger">*</span>
              </label>
              <Field name="continent" v-slot="{ field }">
                <Multiselect
                  :options="continentOptions"
                  :searchable="false"
                  mode="tags"             
                  track-by="value"
                  label="label"
                  v-model="field.value"
                  v-bind="field"
                  placeholder="Sélectionnez un ou plusieurs continents"
                />
              </Field>
              <ErrorMessage name="continent" class="text-danger" />
              <small class="text-muted">Sélectionnez tous les continents concernés par cette zone</small>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Pays
              </label>
              <Field name="paysId" v-slot="{ field }">
                <Multiselect :options="paysOptions" :searchable="true" multiple="false" track-by="label"
                  label="label" v-model="field.value" v-bind="field" placeholder="Sélectionner le pays" />
              </Field>
              <ErrorMessage name="paysId" class="text-danger" />
              <small class="text-muted">Optionnel - Laissez vide pour toute zone</small>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Port 
              </label>
              <Field name="portId" v-slot="{ field }">
                <Multiselect
                  v-model="field.value"
                  v-bind="field"
                  :options="ports"
                  :searchable="true"
                  :loading="loadingPorts"
                  placeholder="Rechercher (nomPort ou locode)..."
                  label="label"
                  track-by="value"
                  @search-change="searchPort"
                  :filter-results="false"
                  :min-chars="2"
                />
              </Field>
              <ErrorMessage name="portId" class="text-danger" />
              <small class="text-muted">Optionnel - Laissez vide pour tous les ports</small>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de début
              </label>
              <Field name="effectiveFrom" type="date" class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="effectiveFrom" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Date de fin
              </label>
              <Field name="effectiveTo" type="date" class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="effectiveTo" class="text-danger" />
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Description
              </label>
              <Field name="description" as="textarea" rows="3" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Décrivez la portée de la zone (pays, port, type de flux, marchandises...)" />
              <ErrorMessage name="description" class="text-danger" />
            </div>
          </div>

          <div class="col-md-12">
            <div class="d-flex align-items-center">
              <button
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit">
                {{ btntext }}
              </button>
              <router-link to="/listeTariffZone" 
                class="btn btn-danger transition border-0 lh-1 fw-medium">
                <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import { error, success } from '@/utils/utils';
import { useRouter, useRoute } from 'vue-router';
import Multiselect from '@vueform/multiselect';

export default defineComponent({
  name: "AddTariffZone",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  setup() {
    const tariffZoneSchema = Yup.object().shape({
      code: Yup.string().required('Le code est obligatoire'),
      name: Yup.string().required("Le nom est obligatoire"),
      continent: Yup.array()
        .of(Yup.string().oneOf(['AFRIQUE', 'EUROPE', 'ASIE', 'AMERIQUE', 'OCEANIE'], 'Continent invalide'))
        .min(1, 'Au moins un continent est obligatoire')
        .required('Le(s) continent(s) sont obligatoires'),
      });

    const tariffZoneForm = ref<any | null>(null);
    const router = useRouter();
    const route = useRoute();
    const isUPDATE = ref(false);
    const title = ref("Ajouter une zone tarifaire");
    const btntext = ref('Ajouter');
    const paysOptions = ref([]);
    const ports = ref<{ value: number; label: string }[]>([]);   
    const loadingPorts = ref(false);
    let searchTimeout: ReturnType<typeof setTimeout> | null = null;

    const continentOptions = ref([
      { value: 'AFRIQUE', label: 'Afrique' },
      { value: 'EUROPE', label: 'Europe' },
      { value: 'ASIE', label: 'Asie' },
      { value: 'AMERIQUE', label: 'Amérique' },
      { value: 'OCEANIE', label: 'Océanie' },
    ]);

    const fetchPays = async () => {
      try {
        const response = await ApiService.get('/pays?limit=0');
        const paysData = response.data.data.data;
        paysOptions.value = paysData.map((pays) => ({
          value: pays.id,
          label: `${pays.iso2_code} - ${pays.name_fr}`,
        }));
      } catch (error) {
        console.error('Erreur chargement pays:', error);
      }
    };

    const searchPort = async (query: string) => {
      if (searchTimeout) clearTimeout(searchTimeout);

      if (!query || query.length < 2) {
        ports.value = [];
        return;
      }

      searchTimeout = setTimeout(async () => {
        loadingPorts.value = true;
        try {
          const response = await ApiService.get(
            `/Liste/port?search=${encodeURIComponent(query)}`
          );
          const portsData = response.data?.data || [];

          ports.value = portsData.map((port: any) => ({
            label: `${port.nomPort} - ${port.locode}`,
            value: port.id,
          }));
        } catch (err) {
          console.error('Erreur recherche ports:', err);
          ports.value = [];
        } finally {
          loadingPorts.value = false;
        }
      }, 300);
    };

    const getTariffZone = async (id: string) => {
      try {
        const { data } = await ApiService.get("/tariff-zone/" + id);
        const donnees = data.data;
      
        for (const key in donnees) {
          if (key === 'regions') {
            tariffZoneForm.value?.setFieldValue(key, donnees[key]);
          } else {
            tariffZoneForm.value?.setFieldValue(key,
              (typeof donnees[key] === 'object' && donnees[key] !== null) ? donnees[key].id : donnees[key]
            );
          }
        }

        tariffZoneForm.value?.setFieldValue('isDefault', donnees.isDefault === true);
        tariffZoneForm.value?.setFieldValue('isActive', donnees.isActive !== false);

        isUPDATE.value = true;
        title.value = "Modifier une zone tarifaire";
        btntext.value = "Modifier";
      } catch (err) {
        error('Erreur lors du chargement de la zone tarifaire');
        router.push({ name: 'ListeTariffZonePage' });
      }
    };

    const addTariffZone = async (values: any, { resetForm }: any) => {
      try {
        let response;

        const payload = {
          code: values.code,
          name: values.name,
          description: values.description,
          continent: values.continent || [],
          paysId: values.paysId?.value || values.paysId || null,
          portId: values.portId?.value || values.portId || null,
          isDefault: values.isDefault === true, 
          isActive: values.isActive !== false,   
          effectiveFrom: values.effectiveFrom || null,
          effectiveTo: values.effectiveTo || null,
        };

        console.log(' Payload envoyé au backend:', payload);
        console.log(' Valeurs brutes du formulaire:', {
          isDefault_brut: values.isDefault,
          isDefault_type: typeof values.isDefault,
          isDefault_converti: payload.isDefault,
          isActive_brut: values.isActive,
          isActive_type: typeof values.isActive,
          isActive_converti: payload.isActive
        });

        if (isUPDATE.value) {
          response = await ApiService.put(`/tariff-zone/${route.params.id}`, payload);
        } else {
          response = await ApiService.post('/tariff-zone', payload);
        }

        const result = response.data;
        console.log(' Réponse API complète :', result);
        success(result.message || 'Opération réussie !');
        if (!isUPDATE.value) {
          resetForm();
        }
        router.push({ name: 'ListeTariffZonePage' });
      } catch (err: any) {
        console.error(' Erreur réelle lors de la sauvegarde :', err);
        const msg = err.response?.data?.message
                || err.response?.data?.error
                || err.message
                || 'Erreur inconnue';
        error(msg);
      }
    };

    const getContinentLabel = (value: string) => {
      const map: Record<string, string> = {
        AFRIQUE: 'Afrique',
        EUROPE: 'Europe',
        ASIE: 'Asie',
        AMERIQUE: 'Amérique',
        OCEANIE: 'Océanie',
      };
      return map[value] || value;
    };

    onMounted(() => {
      fetchPays();

      if (route.params.id) {
        getTariffZone(route.params.id as string);
      } else {
        tariffZoneForm.value?.setFieldValue('isActive', true);
        tariffZoneForm.value?.setFieldValue('isDefault', false);
      }
    });

    return {
      tariffZoneSchema,
      addTariffZone,
      tariffZoneForm,
      title, 
      btntext, 
      paysOptions,
      continentOptions,
      getContinentLabel,
      ports, 
      loadingPorts,
      searchPort
    };
  },
});
</script>